var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFigma(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 75,
    cy: 75,
    r: 75,
    fill: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_53)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M58.2891 126.925C66.7834 126.925 73.6773 120.176 73.6773 111.86V96.7964H58.2891C49.7948 96.7964 42.9009 103.545 42.9009 111.86C42.9009 120.176 49.7948 126.925 58.2891 126.925Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M42.9009 81.7326C42.9009 73.4172 49.7948 66.6685 58.2891 66.6685H73.6773V96.7967H58.2891C49.7948 96.7967 42.9009 90.0479 42.9009 81.7326Z",
    fill: "#A259FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M42.9009 51.6041C42.9009 43.2888 49.7948 36.54 58.2891 36.54H73.6773V66.6682H58.2891C49.7948 66.6682 42.9009 59.9195 42.9009 51.6041Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M73.6772 36.54H89.0655C97.5598 36.54 104.454 43.2888 104.454 51.6041C104.454 59.9195 97.5598 66.6682 89.0655 66.6682H73.6772V36.54Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M104.454 81.7326C104.454 90.0479 97.5598 96.7967 89.0655 96.7967C80.5712 96.7967 73.6772 90.0479 73.6772 81.7326C73.6772 73.4172 80.5712 66.6685 89.0655 66.6685C97.5598 66.6685 104.454 73.4172 104.454 81.7326Z",
    fill: "#1ABCFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_53"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61.5529,
    height: 90.3846,
    fill: "white",
    transform: "translate(42.9009 36.54)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/Figma.21f9035c8198a15adb5d70be534f5c5d.svg";
export { ForwardRef as ReactComponent };